import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { Firestore } from "../firebase/firebase";
import { useSelector, useDispatch } from "react-redux";
import { getAdvertisers, changeStatus } from "../firebase";
import {
  fetchBanner,
  fetchTemplate,
  fetchAdvertisers,
  fetchRetailer,
  fetchCurrentAdvertiser,
} from "../actions";
import NotFound from "../app/404";
import Loading from "../app/loading";
import Default from "../templates/default/stage";
import CompManager from "./component-manager";

const Banner = () => {
  const location = useLocation();
  const { id, retailer } = useParams();

  const dispatch = useDispatch();

  const banner = useSelector((state) => state.banner);
  const user = useSelector((state) => state.user);
  const retailers = useSelector((state) => state.retailers);

  const [currentRetailer, setCurrentRetailer] = useState();
  const [hideBanner, setHideBanner] = useState(true);

  const [value, loading, error] = useDocument(
    doc(Firestore, "banners", id),
    //Firestore.collection("banners").doc(id),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  useEffect(() => {
    dispatch(fetchRetailer(retailer));
    return () => {
      dispatch(fetchRetailer(null));
    };
  }, [retailer, dispatch]);

  useEffect(() => {
    if (banner.advertiser) dispatch(fetchCurrentAdvertiser(banner.advertiser));
    //return () => {
    //  dispatch(fetchAdvertiser(null));
    //};
  }, [banner, dispatch]);

  // get advertisers for current retailer
  useEffect(() => {
    if (user) getAdvertisers(retailer, user, dispatch);
    return () => dispatch(fetchAdvertisers([]));
  }, [retailer, user, dispatch]);

  useEffect(() => {
    if (retailers) {
      const r = _.find(retailers, (o) => {
        return o.name === retailer;
      });
      setCurrentRetailer(r);
    }
  }, [retailers, retailer]);

  // get template data from temp until templates loaded into retailers
  useEffect(() => {
    if (currentRetailer && banner.bannerType) {
      const t = _.find(currentRetailer.templates, (o) => {
        return o.name === banner.bannerType;
      });
      dispatch(fetchTemplate(t));
    }
  }, [dispatch, currentRetailer, banner]);

  // put banner into state
  useEffect(() => {
    if (value) {
      if (value.exists) {
        const data = { ...value.data() };
        data.key = value.id;
        dispatch(fetchBanner(data));
      }
    }
    return () => {
      dispatch(fetchBanner({}));
    };
  }, [value, dispatch]);

  useEffect(() => {
    const loc = location.pathname.split("/")[4];
    if (user && loc === "edit") {
      if (!banner.currentUser && banner.key) changeStatus(id, user);
    }
  }, [location, id, user, banner]);

  useEffect(() => {
    if (!_.isEmpty(banner)) {
      setHideBanner(false);
    }
  }, [banner]);

  useEffect(() => {
    if (error) setHideBanner(false);
  }, [error]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (loading || hideBanner) return <Loading />;
  if (error || !value.exists) return <NotFound />;

  return (
    <div className={`bm-template ${banner.bannerType}-template`}>
      {banner.templateType === "bespoke" && (
        <CompManager
          compName={`Stage${banner.bannerType}`}
          id={id}
          location={location}
          retailer={retailer}
        />
      )}
      {banner.templateType === "hybrid" && (
        <CompManager
          compName={`Stage${banner.bannerType}`}
          id={id}
          location={location}
          retailer={retailer}
        />
      )}
      {(banner.templateType === "native" ||
        banner.templateType === "custom") && (
        <Default id={id} location={location} retailer={retailer} />
      )}
      {banner.templateType === "standard" && (
        <CompManager
          compName={`${capitalizeFirstLetter(banner.service)}Standard`}
          retailer={retailer}
          id={id}
          location={location}
        />
      )}
    </div>
  );
};

export default Banner;
